<template>
  <div class="clientCommon">
    <com-form
      ref="clientCommon"
      label-width="120px"
      label-position="right"
      :col="3"
      :configs="filterFormConfig"
    ></com-form>
  </div>
</template>

<script>
import { formConfig } from "../config/formConfig.js"

export default {
  name: 'clientCommon',
  data() {
    const config = formConfig(this);
    return {
      formData: {},
      filterFormConfig: config.commmonFormConfig[0].tagConfigs
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>